import { useEffect, useState } from 'react';

/**
 * Matches the breakpoint used in the stylesheet. Kept in JavaScript as
 * well because the phone layout is two steps rather than one screen,
 * and CSS alone cannot express "which step am I on".
 */
const QUERY = '(max-width: 860px)';

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(QUERY).matches);

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const onChange = (event: MediaQueryListEvent) => setIsMobile(event.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}
